import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const SensitiveLabelsTableColumns: ITableColumn[] = [
  {
    labelPath: 'policyPage.config.sensitiveLabelsContent.labelNameColumn',
    propertyKey: 'displayName',
    colType: TableColumnTypeEnum.Text,
    width: 60,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
  {
    labelPath: 'policyPage.config.sensitiveLabelsContent.labelIdColumn',
    propertyKey: 'id',
    colType: TableColumnTypeEnum.Text,
    width: 40,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
];
